import axios, { AxiosInstance } from 'axios'
import { Locale } from '@/types'
import Cookies from 'js-cookie'

import { CookieName } from '@/config/cookies'
import { normalizeLocale } from '@/utils'

class BaseAPIService {
  protected apiClient: AxiosInstance // Declare apiClient with AxiosInstance type

  constructor(serviceUrl: string) {
    if (!serviceUrl) {
      throw new Error(
        `Endpoint for ${serviceUrl} is not defined in the configuration.`
      )
    }

    // Initialize apiClient with the baseURL
    this.apiClient = axios.create({
      baseURL: serviceUrl,
      headers: this.getDefaultHeaders(),
    })
  }

  /**
   * Create a new API client with a different base URL.
   * @param baseURL - The base URL for the new API client
   */
  protected createApiClient(baseURL: string): AxiosInstance {
    return axios.create({
      baseURL,
      headers: this.getDefaultHeaders(),
    })
  }

  /**
   * Get default headers for API requests.
   */
  protected getDefaultHeaders(): { [key: string]: string } {
    return {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      locale: this.getLocale(),
    }
  }

  protected getDefaultParams(): { [key: string]: string } {
    const locale: Locale = this.getLocale()
    const company = Cookies.get(CookieName.COMPANY)
    // if (locale === 'fr-FR-CSE' && !company) {
    //   // FORCE redirect to the domain root (no path) if company is missing in cookies, for fr-FR-CSE locale
    //   // Remove all cookies
    //   Object.keys(Cookies.get()).forEach((cookieName) => {
    //     Cookies.remove(cookieName);
    //   });
    //   window.location.href = "https://cse.travelski.com/"
    //   throw new Error('Company is required for locale fr-FR-CSE.');
    // }
    return {
      ...(locale === 'fr-FR-CSE' && {
        company: company,
      }), // add company if it's cse
    }
  }

  /**
   * Determine the locale for API requests based on the `window.locale`.
   */
  protected getLocale(): Locale {
    return window.env.VUE_APP_LOCALE as Locale
  }

  /**
   * Determine the locale for API requests based on `window.locale`
   * and ensure `en-GB` is converted to `en-US`.
   */
  protected getLegacyLocale(): Locale {
    const locale = window.env.VUE_APP_LOCALE as Locale
    return normalizeLocale(locale)
  }

}

export default BaseAPIService
